module.exports = __webpack_public_path__ + "b42f81667b397bd7039d87f68c57be46.jpg";